<template>
    <div class="assembly">
         <div class="m-left"><span></span> 选择图表</div>
         <div class="select">
            <div :class="['select-item',{'active':selectIndex == index}]" v-for="(item,index) in selectList" :key="index"  @click="select_fn(index)">
                <div class="item-img">
                    <img :src="item.url" alt="" draggable="true" @dragend="dragend_fn($event,item.name)">
                </div>
                <p>{{item.name}}</p>
            </div>

         </div>
        <div class="m-left"><span></span> 编辑属性</div>

        <!-- 折线图 -->
        <div class="line-style" v-if="selectIndex == 0">
            <div class="tab-chat">
                <div><span v-for="(item,index) in tabList" :key="index" :class="[{'active':tabIndex == index}]" @click="tabIndex = index">{{item}}</span></div>
                 <p @click="previewFun">预览</p>
            </div>
            <div class="style-con" v-show="tabIndex == 0">
                <div class="style-item">
                    <span>折线样式</span>
                    <el-checkbox v-model="lineStyleCheck" @change='lineCheck'>曲线</el-checkbox>
                      <el-checkbox v-model="lineShadow">折线阴影</el-checkbox>
                </div>
                 <div class="style-item">
                    <span>网格线</span>
                    <el-switch v-model="lineX" @change="lineX_fn"></el-switch>
                    <p :class="[{'switch-color':lineX}]" style="margin-right:20px">竖线</p>
                    <el-switch v-model="lineY" @change="lineY_fn"></el-switch>
                    <p :class="[{'switch-color':lineY}]">横线</p>
                </div>
                  <div class="style-item">
                    <span>数据标记</span>
                    <el-switch v-model="lineMark" @change="lineMark_fn"></el-switch>
                    <p :class="[{'switch-color':lineMark}]">{{lineMark ? '显示':'隐藏'}}</p>
                </div>
                  <div class="style-item" v-show="lineMark">
                    <span>数据标签</span>
                    <el-switch v-model="lineLabel" @change="lineLabel_fn"></el-switch>
                    <p :class="[{'switch-color':lineLabel}]">{{lineLabel ? '显示':'隐藏'}}</p>
                </div>
            </div>
            <div class="line-data-x" v-show="tabIndex == 1">
                    <div class="axis">
                            <div class="time-radio">
                                日期
                                  <el-select v-model="lineTime" placeholder="请选择" style="width:90px;margin-left:10px">
                                      <el-option v-for="item in axisOptions"  :key="item.value" :label="item.label" :value="item.value"> </el-option>
                                  </el-select>
                            </div>
                        
                    </div>
                   <div class="variable-tree">
                        <div class="variable-name" :style="{'height':heights+'px'}">
                            <el-scrollbar style="height:100%;width: 100%;">
                             <div class="name-item" v-for="(item,index) in variableNameArr" :key="index">
                                <span style="margin-right:7px">系列{{index+1}}</span> <el-input  v-model="item.vName" placeholder="请输入"  style="width:160px" @focus='focus_fn(index)' @input='input_fn'> </el-input>
                                <img src="@/assets/unifyImg/remove.png" @click="del_fn(index)">
                             </div>
                             
                               </el-scrollbar>
                             <div class="add-icon" @click="addName_fn">
                                +
                             </div>
                        </div>
                         <div class="direct">
                        <div class="data-type">
                            <p>正在绑定：{{xuanzhong}}</p>
                            <span>应用类型：</span>
                            <el-select v-model="screenTypevalue" clearable placeholder="选择应用类型" style="width:210px">
								<el-option v-for="t in screenTypeData" :key="t.id" :label="t.name" :value="t.id"></el-option>
							</el-select>
                        </div>
                          <div class="variable-tree" :style="{'height':heights+'px'}">
                            <el-scrollbar style="height:100%;width: 100%;">
                                <el-tree
                                        class="filter-tree"
                                        :data="treeList"
                                        show-checkbox
                                        :props="defaultProps2"
                                        node-key="keyId"
                                        highlight-current
                                        @check="currentChecked"
                                        ref="tree"
                                       >
                                        <span class="custom-tree-node" slot-scope="{node}" >
                                             <div v-if="routeData.kanBanType == '指定'">
                                                <img src="../../../public/static/image/elTree/1.9.png" style="margin-right: 2px;" 
                                                    v-if="node.data.Content.Category && node.data.Content.Category == 'Organization'"/>

                                                    <img src="../../../public/static/image/elTree/variable.png" style="margin-right: 2px;" 
                                                    v-if="node.data.Content.variableName"/>

                                                    <img src="../../../public/static/image/elTree/2.1.png" style="margin-right: 2px; position: relative;top: 1px;" 
                                                    v-if="node.data.Content.Category &&  node.data.Content.Category == 'Device'"/>
                                             </div>
                                             <div v-if="routeData.kanBanType == '通用'">
                                                  <img src="../../../public/static/image/elTree/variable.png" style="margin-right: 2px;" 
                                                    v-if="node.data.Content.Category == 'AppType'"/>

                                                    <img src="../../../public/static/image/elTree/2.1.png" style="margin-right: 2px; position: relative;top: 1px;" 
                                                    v-if="node.data.Content.Category == 'AppTypeGroup'"/>
                                             </div>
                                             <span style="padding-left: 5px;" >{{node.data.Content.Name}}</span>
                                        </span>
                                         
                                        
                                </el-tree>
                                 <!-- 看板类型为通用 -->
                            </el-scrollbar>
                          
                        </div>
                         </div>
                   </div>
                    
                    
            </div>
            
            
        </div>
        <!-- 柱状图 -->
         <div class="line-style" v-if="selectIndex == 1">
            <div class="tab-chat">
                <div><span v-for="(item,index) in tabList" :key="index+10" :class="[{'active':tabIndex == index}]" @click="tabIndex = index">{{item}}</span></div>
                <p @click="previewFun">预览</p>
            </div>
           <div class="style-con" v-show="tabIndex == 0">
                <div class="style-item">
                    <span>柱状类型</span>
                   <el-checkbox v-model="barParameter.barStyleCheck" @change='barStyleCheck_fn'>圆角</el-checkbox>
                </div>
                 <div class="style-item">
                    <span>网格线</span>
                    <el-switch v-model="barParameter.barX" @change="barX_fn"></el-switch>
                    <p :class="[{'switch-color':barParameter.barX}]" style="margin-right:20px">竖线</p>
                    <el-switch v-model="barParameter.barY" @change="barY_fn"></el-switch>
                    <p :class="[{'switch-color':barParameter.barY}]">横线</p>
                </div>
                <div class="style-item">
                    <span>数据标签</span>
                    <el-switch v-model="barParameter.barLabel" @change="barLabel_fn"></el-switch>
                    <p :class="[{'switch-color':barParameter.barLabel}]">{{barParameter.barLabel ? '显示':'隐藏'}}</p>
                </div>
                 <!-- <div class="style-item">
                    <span>单位</span>
                    <el-input v-model="barParameter.unitVal" placeholder="请输入" style="width:1rem;margin-right:12px"></el-input>
                    <el-switch v-model="barParameter.unitIsShow" @change="unitIsShow_fn"></el-switch>
                    <p :class="[{'switch-color':barParameter.unitIsShow}]">{{barParameter.unitIsShow ? '显示':'隐藏'}}</p>
                </div> -->

            </div>
            <div class="line-data-x" v-show="tabIndex == 1">
                    <div class="axis">
                            <div class="time-radio">
                                日期
                                  <el-select v-model="lineTime" placeholder="请选择" style="width:90px;margin-left:10px">
                                      <el-option v-for="item in axisOptions"  :key="item.value" :label="item.label" :value="item.value"> </el-option>
                                  </el-select>
                            </div>
                        
                    </div>
                    <div class="variable-tree">
                        <div class="variable-name" :style="{'height':heights+'px'}">
                            <el-scrollbar style="height:100%;width: 100%;">
                             <div class="name-item" v-for="(item,index) in variableNameArr" :key="index">
                                <span style="margin-right:7px">系列{{index+1}}</span> <el-input  v-model="item.vName" placeholder="请输入"  style="width:160px" @focus='focus_fn(index)'> </el-input>
                                <img src="@/assets/unifyImg/remove.png" @click="del_fn(index)">
                             </div>
                             
                               </el-scrollbar>
                             <div class="add-icon" @click="addName_fn">
                                +
                             </div>
                        </div>
                         <div class="direct">
                        <div class="data-type">
                            <p>正在绑定：{{xuanzhong}}</p>
                            <span>应用类型：</span>
                            <el-select v-model="screenTypevalue" clearable placeholder="选择应用类型" style="width:210px">
								<el-option v-for="t in screenTypeData" :key="t.id" :label="t.name" :value="t.id"></el-option>
							</el-select>
                        </div>
                          <div class="variable-tree" :style="{'height':heights+'px'}">
                            <el-scrollbar style="height:100%;width: 100%;">
                                <el-tree
                                        class="filter-tree"
                                        :data="treeList"
                                        show-checkbox
                                        :props="defaultProps2"
                                         node-key="keyId"
                                        @check="currentChecked"
                                        ref="tree"
                                       >
                                        <span class="custom-tree-node" slot-scope="{node}" >
                                             <div v-if="routeData.kanBanType == '指定'">
                                                <img src="../../../public/static/image/elTree/1.9.png" style="margin-right: 2px;" 
                                                    v-if="node.data.Content.Category && node.data.Content.Category == 'Organization'"/>

                                                    <img src="../../../public/static/image/elTree/variable.png" style="margin-right: 2px;" 
                                                    v-if="node.data.Content.variableName"/>

                                                    <img src="../../../public/static/image/elTree/2.1.png" style="margin-right: 2px; position: relative;top: 1px;" 
                                                    v-if="node.data.Content.Category &&  node.data.Content.Category == 'Device'"/>
                                             </div>
                                             <div v-if="routeData.kanBanType == '通用'">
                                                  <img src="../../../public/static/image/elTree/variable.png" style="margin-right: 2px;" 
                                                    v-if="node.data.Content.Category == 'AppType'"/>

                                                    <img src="../../../public/static/image/elTree/2.1.png" style="margin-right: 2px; position: relative;top: 1px;" 
                                                    v-if="node.data.Content.Category == 'AppTypeGroup'"/>
                                             </div>
                                             <span style="padding-left: 5px;" >{{node.data.Content.Name}}</span>
                                        </span>
                                         
                                        
                                </el-tree>
                                 <!-- 看板类型为通用 -->
                            </el-scrollbar>
                          
                        </div>
                         </div>
                   </div>
                    
            </div>
           
            
            

            
        </div>

        <!-- 饼图 -->
         <div class="line-style" v-if="selectIndex == 2">
            <div class="tab-chat">
                <div><span v-for="(item,index) in tabList" :key="index + 20" :class="[{'active':tabIndex == index}]" @click="tabIndex = index">{{item}}</span></div>
                <p>预览</p>
            </div>
           <div class="style-con" v-show="tabIndex == 0">
                <div class="style-item">
                    <span>饼图类型</span>
                   <el-checkbox v-model="pieParameter.pieStyle" @change='pieStyle_fn'>环形</el-checkbox>
                </div>
                <div class="style-item">
                    <span>数据标签</span>
                    <el-switch v-model="pieParameter.label" @change="pieLabel_fn"></el-switch>
                    <p :class="[{'switch-color':pieParameter.label}]">{{pieParameter.label ? '显示':'隐藏'}}</p>
                </div>
                <div class="style-item">
                    <span>图例</span>
                    <el-switch v-model="pieParameter.legendIsShow" @change="legendIsShow_fn"></el-switch>
                    <p :class="[{'switch-color':pieParameter.legendIsShow}]">{{pieParameter.legendIsShow ? '显示':'隐藏'}}</p>
                </div>
            </div>
            <div class="line-data-x" v-show="tabIndex == 1">
                    <div class="axis">
                            <div class="time-radio">
                                日期
                                  <el-select v-model="lineTime" placeholder="请选择" style="width:90px;margin-left:10px">
                                      <el-option v-for="item in axisOptions"  :key="item.value" :label="item.label" :value="item.value"> </el-option>
                                  </el-select>
                            </div>
                        
                    </div>
                     <div class="variable-tree">
                        <div class="variable-name" :style="{'height':heights+'px'}">
                            <el-scrollbar style="height:100%;width: 100%;">
                             <div class="name-item" v-for="(item,index) in variableNameArr" :key="index">
                                <span style="margin-right:7px">系列{{index+1}}</span> <el-input  v-model="item.vName" placeholder="请输入"  style="width:160px" @focus='focus_fn(index)'> </el-input>
                                <img src="@/assets/unifyImg/remove.png" @click="del_fn(index)">
                             </div>
                             
                               </el-scrollbar>
                             <div class="add-icon" @click="addName_fn">
                                +
                             </div>
                        </div>
                         <div class="direct">
                        <div class="data-type">
                            <p>正在绑定：{{xuanzhong}}</p>
                            <span>应用类型：</span>
                            <el-select v-model="screenTypevalue" clearable placeholder="选择应用类型" style="width:210px">
								<el-option v-for="t in screenTypeData" :key="t.id" :label="t.name" :value="t.id"></el-option>
							</el-select>
                        </div>
                          <div class="variable-tree" :style="{'height':heights+'px'}">
                            <el-scrollbar style="height:100%;width: 100%;">
                                <el-tree
                                        class="filter-tree"
                                        :data="treeList"
                                        show-checkbox
                                        :props="defaultProps2"
                                         node-key="keyId"
                                        @check="currentChecked"
                                        ref="tree"
                                       >
                                        <span class="custom-tree-node" slot-scope="{node}" >
                                             <div v-if="routeData.kanBanType == '指定'">
                                                <img src="../../../public/static/image/elTree/1.9.png" style="margin-right: 2px;" 
                                                    v-if="node.data.Content.Category && node.data.Content.Category == 'Organization'"/>

                                                    <img src="../../../public/static/image/elTree/variable.png" style="margin-right: 2px;" 
                                                    v-if="node.data.Content.variableName"/>

                                                    <img src="../../../public/static/image/elTree/2.1.png" style="margin-right: 2px; position: relative;top: 1px;" 
                                                    v-if="node.data.Content.Category &&  node.data.Content.Category == 'Device'"/>
                                             </div>
                                             <div v-if="routeData.kanBanType == '通用'">
                                                  <img src="../../../public/static/image/elTree/variable.png" style="margin-right: 2px;" 
                                                    v-if="node.data.Content.Category == 'AppType'"/>

                                                    <img src="../../../public/static/image/elTree/2.1.png" style="margin-right: 2px; position: relative;top: 1px;" 
                                                    v-if="node.data.Content.Category == 'AppTypeGroup'"/>
                                             </div>
                                             <span style="padding-left: 5px;" >{{node.data.Content.Name}}</span>
                                        </span>
                                         
                                        
                                </el-tree>
                                 <!-- 看板类型为通用 -->
                            </el-scrollbar>
                          
                        </div>
                         </div>
                   </div>
                    
            </div>
            
         

            
        </div>

   

        
        
        
    </div>
</template>

<script>
import {previewData} from "../../api/customKanBanApi";
export default {
//    props:['nowChartData','routeData'],
    props: {
        //  routeData: {
        //     type: Object,
        //     default: () => ({})
        // },
         nowChartData: {
            type: Object,
            default: () => ({})
        },
        },
    data() {
        return {
            routeData:[],
            //图表X轴数据
            variableNameArr:[],
            variableIndex:-1,
            checkedNodes:[],
			halfCheckedNodes:null,
            //单位
            nowUnitId:"",
            //变量树形图
            defaultProps2: {
					children: 'ChildDatas',
					label: 'Content.Name'
				},
        
            //设备变量树形结构
			treeList: [],
            treeListCopy:[],
            heights: document.getElementById('app').clientHeight-620,
            //组件数据
             selectList:[
                {
                  'name':"折线图",
                  'url':require('@/assets/customKanBan/kanBanChart/line.png'),
                },
                {
                  'name':"柱状图",
                  'url':require('@/assets/customKanBan/kanBanChart/bar.png'),
                },
                {
                  'name':"饼图",
                  'url':require('@/assets/customKanBan/kanBanChart/pie.jpg'),
                }
                
             ],
             //组件选中
             selectIndex:0,
             //选项卡颜色
             tabColor:"#21416C",
             //Tab切换栏
             tabIndex:0,
             //tab样式数据
             tabList:['样式','数据'],
             //折线图以下
             //折线样式
             lineStyleCheck:false,
             //曲线阴影
             lineShadow:false,
             //数据标记
             lineMark:true,
             //数据标签
             lineLabel:false,
             //网格线X
             lineX:true,
             //网格线Y
             lineY:true,
             //数据横轴选择
             lineTime:'MON',
             //折线图以上
             axisOptions:[ {
                value: 'DAY',
                label: '日'
                }, {
                value: 'MON',
                label: '月'
                }],
           //柱状图参数以下
           barParameter:{
              unitVal:"",//单位输入框
              barStyleCheck:false,//是否为圆角
              barX:true,//X轴
              barY:true,//Y轴
              barLabel:false,//数据标签
              unitIsShow:false,//是否显示单位
           },
           //饼图参数
           pieParameter:{
              pieStyle:false,
              label:true,
              legendIsShow:true,
           },
             //变量类型
             screenTypeData:[],
			 screenTypevalue:"",

             //折线图
            lineProportionData: {
                grid: {
                    zlevel:0,
                         left: '8%', // 坐标系左侧的距离
                        right: '5%', // 坐标系右侧的距离
                        top: '8%', // 坐标系顶部的距离
                        bottom: '10%', // 坐标系底部的距离
                        containLabel: false // 是否包含坐标轴刻度标签，默认为false
                    },
             
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                    // Use axis to trigger tooltip
                    type: "shadow", // 'shadow' as default; can also be 'line' or 'shadow'
                    },
                },
                legend: {
                    data: [],
                    bottom: 0,
                    icon: "rect", //  
                    itemWidth: 12, // 设置宽度
                    itemHeight: 12, // 设置高度
                    textStyle: {
                    lineHeight: 56,
                    fontSize: 14,
                    },
                    itemGap: 50, // 设置间距
                },

                xAxis: {
                    splitLine: {  // 控制x轴网格线颜色
                        show:true,
                            lineStyle: {
                                color: '#333333',
                                 type: 'dashed'
                            }
                        },
                    type: "category",
                    axisTick: {
                    show: false,
                    },
                    axisLabel: {
                            interval: 0,
                            rotate: 0,
                            inside: false,
                             textStyle: {
                                color: '#6e7079'
                            }
                    },
                    axisLine: {
                    show: false,
                    },
                    data: ['系列1','系列2','系列3','系列4'],
                },
                yAxis: {
                    splitLine: {  // 控制x轴网格线颜色
                        show:true,
                            lineStyle: {
                                color: '#333333',
                                 type: 'dashed'
                            }
                        },
                    type: "value",
                    axisLabel: {
                            interval: 0,
                            rotate: 0,
                            inside: false,
                             textStyle: {
                                color: '#6e7079'
                            }
                    },
                },
                series: [
                    {
                    name:"",
                    data: [10, 20, 30, 50, 100, 80, 200, 400,300,150,250,20],
                    type: "line",
                    stack: "total",
                    smooth: false,//平滑
                    symbol:"circle",
                    emphasis: {
                        focus: "series",
                    },
                    label: {
                        show: false, // 显示数据标签
                        position: 'top', // 数据标签显示在柱子顶部
                         color: '#6e7079',
                    },
                    },
                     {
                    name:"",
                    data: [10, 20, 30, 50, 100, 80, 200, 400,300,150,250,20],
                    type: "line",
                    stack: "total",
                    smooth: false,//平滑
                    symbol:"circle",
                    emphasis: {
                        focus: "series",
                    },
                    label: {
                        show: false, // 显示数据标签
                        position: 'top', // 数据标签显示在柱子顶部
                         color: '#6e7079',
                    },
                    },
                ],
            },
            lineProportionDataCopy:[],//折线图返回的
            //柱状图
             barProportionData: {
                grid: {
                    zlevel:0,
                        left: '8%', // 坐标系左侧的距离
                        right: '5%', // 坐标系右侧的距离
                        top: '8%', // 坐标系顶部的距离
                        bottom: '25%', // 坐标系底部的距离
                        containLabel: false // 是否包含坐标轴刻度标签，默认为false
                    },
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                    // Use axis to trigger tooltip
                    type: "shadow", // 'shadow' as default; can also be 'line' or 'shadow'
                    },
                },
                color: ["#51c0fe", "#52fff5"],
                legend: {
                    type: 'scroll',
                    data: ["环比","同比"],
                    top: '77%',
                    icon: "rect", //  
                    itemWidth: 12, // 设置宽度
                    itemHeight: 12, // 设置高度
                    textStyle: {
                        lineHeight: 56,
                        fontSize: 14,
                        color:"#6e7079"
                     },
                    itemGap: 50, // 设置间距
                },

                xAxis: {
                    splitLine: {  // 控制x轴网格线颜色
                        show:true,
                            lineStyle: {
                                color: '#262626',
                                 type: 'dashed'
                            }
                        },
                    type: "category",
                    axisTick: {
                    show: false,
                    },
                    axisLabel: {
                        interval: 0,
                        rotate: 0,
                        inside: false,
                        textStyle: {
                                color: '#6e7079'
                            }
                        },
                    axisLine: {
                    show: false,
                    },
                  data: ['系列1','系列2','系列3','系列4'],
                },
                yAxis: {
                    splitLine: {  // 控制x轴网格线颜色
                        show:true,
                            lineStyle: {
                                color: '#262626',
                                 type: 'dashed'
                            }
                        },
                    type: "value",
                      axisLabel: {
                        interval: 0,
                        rotate: 0,
                        inside: false,
                        textStyle: {
                                color: '#6e7079'
                            }
                        },
                },
                series: [
                    {
                    name: "环比",
                    data: [10, 20, 30, 50],
                    type: "bar",
                    itemStyle: {
                        normal: {
                            barBorderRadius: [0, 0, 0, 0] // 数组分别对应左上、右上、右下、左下四个角的圆角半径
                        }
                    },
                    barWidth:'12',
                    label: {
                        show: false, // 显示数据标签
                        position: 'top', // 数据标签显示在柱子顶部
                         color: '#6e7079',
                    },
                    },
                    {
                    name: "同比",
                    data: [20, 30, 40, 60],
                    type: "bar",
                    itemStyle: {
                        normal: {
                            barBorderRadius: [0, 0, 0, 0] // 数组分别对应左上、右上、右下、左下四个角的圆角半径
                        }
                    },
                    barWidth:'12',
                    label: {
                        show: false, // 显示数据标签
                        position: 'top', // 数据标签显示在柱子顶部
                         color: '#6e7079',
                    },
                    },
                ],
            },
            barProportionDataCopy:[],//柱状图返回的
            //饼图
            pieProportionData:{
                tooltip: {
                    trigger: 'item',
                    formatter: '{b} : {c} ({d}%)',//标签
                },
                legend: {
                    type: 'scroll',
                    show:true,
                    // orient: 'vertical',//竖着
                    left: 'center',
                    bottom:'10',
                    textStyle: {
                        color:"#6e7079"
                     },
                },
                series: [
                    {
                    // name: '系列一',
                    type: 'pie',
                    radius: '70%',//单层
                    // radius: ['50%', '70%'],//环形
                    data: [
                        { value: 1048, name: '系列一' },
                        { value: 735, name: '系列二' },
                        { value: 580, name: '系列三' },
                        { value: 484, name: '系列四' },
                        { value: 300, name: '系列五' },
                    ],
                    label: {
                        show: true,
                        color: '#6e7079',
                    },
                    emphasis: {
                        itemStyle: {
                        shadowBlur: 10,
                        shadowOffsetX: 0,
                        shadowColor: 'rgba(0, 0, 0, 0.5)'
                        }
                    }
                    }
                ]
            },
            pieProportionDataCopy:[],
            //日
            dayList:[],
            //月
            monList:[],
            //年
            yearList:[],
           
            arrIndex:-1,//判断是否有选中的图表
            chartType:"CHART_LINE",
            xuanzhong:"",
            lodData:{}
         

        };
    },

    mounted() {
    //   console.log("fkajbkfa");
       this.lineProportionDataCopy = JSON.parse(JSON.stringify(this.lineProportionData))
       this.routeData = this.$store.deviceStore.state.customKanBanList
    },
    computed: {
      unitId(){
               return this.$store.unitStore.state.nowUnit
            },
        // routeData(){
        //     console.log("this.$store.deviceStore.state.customKanBanList",this.$store.deviceStore.state.customKanBanList);
        //     return this.$store.deviceStore.state.customKanBanList
        // }
       

    },
    watch:{
        
        //筛选类型
		screenTypevalue(val){
			this.screenType_fn(val)
				// this.$refs.tree.filter(val);
		},
        unitId(val){
        //    this.getTeamstGroups_fn() // 获取列表数据
        },
        //当前选中的图表
        nowChartData(val){
             console.log("获取",val);
             if(JSON.stringify(val) != '{}'){
                var chartData = JSON.parse(JSON.stringify(val))
                    // this.checkedNodes = chartData.checkedNodes
                    this.lineTime  = chartData.biSearchTimeType
                    this.arrIndex =  val.arrIndex
                    this.chartType = this.chartType_fn(val.type) //图表类型
                    this.lodData  = chartData.resParameter
                    if(JSON.stringify(chartData.resParameter) == '{}'){
                        this.variableNameArr = []
                    }else {
                        this.variableNameArr = chartData.resParameter.resParameter
                    }
                    
                    if(val.type == '折线图'){
                        this.selectIndex = 0
                        var datList = JSON.parse(JSON.stringify(val.optionData))
                        this.lineProportionDataCopy = JSON.parse(JSON.stringify(val.optionData))
                        var flag = datList.series[0].symbol == "circle" ? true :false
                        this.lineProportionData = datList
                        this.lineStyleCheck = datList.series[0].smooth
                        this.lineMark = flag
                        this.lineLabel = datList.series[0].label.show
                        this.lineX = datList.xAxis.splitLine.show
                        this.lineY = datList.yAxis.splitLine.show
                    }
                    if(val.type == '柱状图'){
                        this.selectIndex = 1
                        var datList = JSON.parse(JSON.stringify(val.optionData))
                        this.barProportionDataCopy = JSON.parse(JSON.stringify(val.optionData))
                        this.barProportionData = datList
                        var flag = datList.series[0].itemStyle.normal.barBorderRadius[0] == "10" ? true :false
                        this.barParameter.barStyleCheck = flag
                        this.barParameter.barX = datList.xAxis.splitLine.show
                        this.barParameter.barY = datList.yAxis.splitLine.show
                        this.barParameter.barLabel = datList.series[0].label.show
                    }
                    if(val.type == '饼图') {
                        this.selectIndex = 2
                         var datList = JSON.parse(JSON.stringify(val.optionData))
                        this.pieProportionDataCopy = JSON.parse(JSON.stringify(val.optionData))
                        this.pieProportionData = datList
                    }
              }else {
                 this.arrIndex = -1
              }

        },
        //看板类型
        routeData(val){
            //  this.treeList = this.$store.deviceStore.state.customKanBanList
             this.treeList = val
             this.treeListCopy = JSON.parse(JSON.stringify(this.treeList))
             var that = this
            setTimeout(() => {
                 that.screenTypeData = that.$store.deviceStore.state.kanBanAppTypeGroup
                //  console.log("应用类型",that.screenTypeData); 
            },200)
        },
        
    },

    methods: {
        //点击图表类型
        select_fn(index){
            this.selectIndex = index
            if(index == 0){
                this.chartType = "CHART_LINE"
            }else if(index == 1){
                this.chartType = "CHART_COLUMN"
            }else if(index ==2){
                 this.chartType = "CHART_PIE"
            }

        },
        //新增
        addName_fn(){
            if(this.arrIndex == -1){
                this.$message({ showClose: true, message: '请先选中图表', type: 'warning'});
                return
            }
             this.variableNameArr.push({
                'vName':"",
                "biCategory": 'SINGLE_ASSORTED',
                "resJsonPars": [],
                "tag": this.chartType+(this.arrIndex + 1)+'_SINGLE'+(this.variableNameArr.length + 1),
                "checkedNodes":[]
             })
        },
        //删除
        del_fn(index){
            this.variableNameArr.splice(index,1)
        },
        //输入框获取焦点
        focus_fn(index){
             this.$refs.tree.setCheckedKeys([]);
            this.variableIndex = index
            this.xuanzhong = this.variableNameArr[index].vName
            this.$refs.tree.setCheckedNodes(this.variableNameArr[index].checkedNodes);
          
        },
        //输入框输入
        input_fn(val){
           this.xuanzhong =val
        },
        //图表类型
        chartType_fn(val){
            if(val == "折线图"){
                return  'CHART_LINE'
            }else if(val == '柱状图'){
                return 'CHART_COLUMN'
            }else {
                return 'CHART_PIE'
            }
        },
        //预览
        previewFun(){
            if(this.arrIndex == -1){
                this.$message({ showClose: true, message: '请先选中图表', type: 'warning'});
                return
            }
            
            var d = {
                "biType": this.routeData[0].kanBanType =='指定' ? 'CUSTOMIZED' :  'UNIVERSAL',
                "resParameter": this.variableNameArr,
                "resType": 0,
                "unitId": this.routeData[0].Content.UnitId
            }
            
            console.log("参数",d);
            var xAxisData = []
            var sameCompare = [] //同比
            var lastCompare = [] //环比
            // this.variableNameArr.forEach(item => {
            //     xAxisData.push(item.vName)
            // })
             previewData(d).then(res => {
           
            
                var data = res.data.biViews
                if(res.code == 200){
                    this.variableNameArr.forEach(item => {
                        xAxisData.push(item.vName)
                        var index = data.findIndex(t => t.tag == item.tag)
                        lastCompare.push(data[index].data.lastCompareValue)
                        sameCompare.push(data[index].data.sameCompareValue)
                         //方正定制版
                         console.log("lineProportionDataCopy报错",this.lineProportionDataCopy);
                        if(this.chartType == 'CHART_LINE'){
                            this.lineProportionDataCopy.xAxis.data = xAxisData
                            this.lineProportionDataCopy.series[0].data = lastCompare
                            this.lineProportionDataCopy.series[1].data = sameCompare
                            this.$emit('changChart',this.lineProportionDataCopy,d)
                        }else if(this.chartType == 'CHART_COLUMN'){
                            this.barProportionDataCopy.xAxis.data = xAxisData
                            this.barProportionDataCopy.series[0].data = lastCompare
                            this.barProportionDataCopy.series[1].data = sameCompare
                            this.$emit('changChart',this.barProportionDataCopy,d)
                        }
                    })
                     this.$message({ showClose: true, message: '预览成功', type: 'success'})
                } else {
                   res.message ?  this.$message({ showClose: true, message:  res.message, type: 'warning'}) : this.$message({ showClose: true, message: '预览失败', type: 'warning'})
                }
            })
            
             
            
        },
        //拖放
        dragend_fn(e,index){
            var clientX = e.clientX
            var clientY = e.clientY
           this.$refs.tree.setCheckedKeys([]);
            var d  = {
                 'clientX':clientX, 
                 'clientY':clientY,
                'type':index,
                'tabIndex':3,
                'optionData':{},
                'biSearchTimeType':this.lineTime,
                'resParameter':{}
            }
            if(index == '折线图'){
                d.optionData = this.lineProportionData
                d.biCategory = "CHART_LINE"
                this.selectIndex = 0
            }else if(index == '柱状图'){
               d.optionData = this.barProportionData
            //    d.unitIsShow = this.unitIsShow
            //    d.unitVal = this.unitVal
               d.biCategory = "CHART_COLUMN"
                this.selectIndex = 1
            }else if(index == '饼图'){
                 this.selectIndex = 2
                 d.biCategory = "CHART_PIE"
               d.optionData = this.pieProportionData
            }
            
            // console.log("参数参数",d);
            // this.$emit('assembly_fn',d)
            this.$emit('chart_fn',d)
        },
        //树形结构选中节点
			 currentChecked (nodeObj, SelectedObj) {
				this.checkedNodes = SelectedObj.checkedNodes
				if(this.routeData[0].kanBanType == '指定'){
                        this.checkedNodes.forEach((item,index) => {
                            if(!item.Content.hasOwnProperty('variableName')){
                                this.checkedNodes.splice(index,1)
                            }
                        })
                        this.checkedNodes.forEach((item,index) => {
                            if(item.hasOwnProperty('ChildDatas')){
                                this.checkedNodes.splice(index,1)
                            }
                        })
                 }else {
                      this.checkedNodes.forEach((item,index) => {
                            if(item.Content.Category == "AppTypeGroup"){
                                this.checkedNodes.splice(index,1)
                            }
                        })
                 }
            //    if(this.arrIndex != -1){
            //       this.fusingleChange()
            //    }
               var viArr = []
                this.checkedNodes.forEach(item => {
                    viArr.push({
                        'dateType':this.lineTime,
                        'variableName':this.routeData[0].kanBanType =='指定' ? item.Content.variableName :  item.Content.Name,
                        'appType':item.Content.appType,
                    })
                })
                this.variableNameArr[this.variableIndex].resJsonPars = JSON.stringify(viArr)
                this.variableNameArr[this.variableIndex].checkedNodes = this.checkedNodes
                // console.log("halfCheckedNodes",this.halfCheckedNodes);

				
            },
            //类型筛选
            screenType_fn(value){
                    var a = JSON.parse(JSON.stringify(this.treeListCopy))
                    console.log("this.treeListCopy",this.treeListCopy);
                    if(value == ""){
                        this.treeList  = a 
                        return
                    }
                    if(this.routeData[0].kanBanType == '指定'){
                        var recursiveFunction = function(){
                                    const getStr = function(list){
                                        list.forEach(function(row){
                                            if(row.Content.Category == "Device"){
                                            row.ChildDatas = 	row.ChildDatas.filter(v => v.Content.Id == value)
                                            }else {
                                                if(row.ChildDatas == null){
                                                    row.ChildDatas = []
                                                }
                                                    getStr(row.ChildDatas)
                                            }
                                        })
                                    }
                                    getStr(a)
                                }
                            recursiveFunction()
                            this.treeList = a
                    }else {
                        var newArr =  a.filter(item => item.Content.id == value)
                        this.treeList = newArr
                    }
                    
                    
                },
       
        //折线图操作(以下)
            //是否切换为平滑(曲线)
            lineCheck(val){
                this.lineProportionDataCopy.series.forEach(item => item.smooth = val)
                this.$emit('changChart',this.lineProportionDataCopy,this.lodData)
            },
            //网格线
            lineX_fn(val){
                this.lineProportionDataCopy.xAxis.splitLine.show = val
                this.$emit('changChart',this.lineProportionDataCopy,this.lodData)
            },
            lineY_fn(val){
                this.lineProportionDataCopy.yAxis.splitLine.show = val
                this.$emit('changChart',this.lineProportionDataCopy,this.lodData)
            },
            //数据标记
            lineMark_fn(val){
                console.log("数据标记",this.lineProportionDataCopy);
                var flag = val?'circle':'none'
                this.lineProportionDataCopy.series.forEach(item => item.symbol = flag)
                this.$emit('changChart',this.lineProportionDataCopy,this.lodData)
            },
            //数据标签
            lineLabel_fn(val){
                this.lineProportionDataCopy.series.forEach(item => item.label.show = val)
                this.$emit('changChart',this.lineProportionDataCopy,this.lodData)
                
            },
        //折线图操作(以上)


         
        //柱状图操作(以下)
            //是否为圆角
            barStyleCheck_fn(val){
                var arr = []
                if(val){
                   arr = [10, 10, 0, 0]
                }else {
                     arr = [0, 0, 0, 0]
                }
                this.barProportionDataCopy.series.forEach(item => item.itemStyle.normal.barBorderRadius = arr)
                this.$emit('changChart',this.barProportionDataCopy,this.lodData)
            },
            //网格线
            barX_fn(val){
                this.barProportionDataCopy.xAxis.splitLine.show = val
                this.$emit('changChart',this.barProportionDataCopy,this.lodData)
            },
            barY_fn(val){
                this.barProportionDataCopy.yAxis.splitLine.show = val
                this.$emit('changChart',this.barProportionDataCopy,this.lodData)
            },
            //数据标签
            barLabel_fn(val){
                this.barProportionDataCopy.series.forEach(item => item.label.show = val)
                this.$emit('changChart',this.barProportionDataCopy,this.lodData)
            },
            //是否显示单位
            unitIsShow_fn(val){

            },
        //柱状图操作(以上)

        //饼图操作(以下)
            //饼图类型
            pieStyle_fn(val){
                this.pieProportionDataCopy.series[0].radius = val ? ['40%', '70%'] : "70%"
                this.$emit('changChart',this.pieProportionDataCopy)
            },
            //数据标签
            pieLabel_fn(val){
                this.pieProportionDataCopy.series[0].label.show = val
                this.$emit('changChart',this.pieProportionDataCopy)
            },
            //图例
            legendIsShow_fn(val){
                this.pieProportionDataCopy.legend.show = val
                this.$emit('changChart',this.pieProportionDataCopy)
            },
        //饼图操作(以上)
      
       
        
       
    },
};
</script>

<style lang="scss" scoped>
.assembly{
    .m-left {
        color: #359EFF;
        display: flex;
        align-items: center;
        span {
            background-color: #359EFF;
            display: inline-block;
            width: 2px;
            height: 12px;
            margin-right: 4px;

        }
    }
    .select {
       display: flex;
       flex-wrap: wrap;
       justify-content: space-between;
       margin-bottom: 20px;
       color: transparent;
        
        .select-item {
            width: 31%;
            height: 100px;
            background-color: #000000;
            margin-top: 15px;
            display: flex;
            justify-content: center;
            flex-wrap: wrap;
             transition: all 0.3s;
            border: 2px solid transparent;
            .item-img {
                width: 95%;
                height: 68px;
                margin-top: 5px;
                display: flex;
                align-items: center;
                justify-content: center;
                overflow: hidden;
                img {
                    // max-width: 95%;
                    width: 100%;
                    height: 100%;
                }

            }
            &.active {
                border: 2px solid aqua;
                // border: 2px solid #0085FF;

            }
     
          &:hover {
				/* 鼠标悬浮时盒子出现的阴影 */
                //    box-shadow: 0px 1px 12px 0px #cccccc;
				transform: translate(0, -5px);/* 鼠标悬浮时盒子上移10px */
			}
            p {
                color: #999999;
            }
        }
    }
    .line-style {
        margin-top: 10px;
        .style-con {
            .style-item {
                
                display: flex;
                align-items: center;
                margin-top: 20px;
               
                span {
                    margin-right: 20px;
                    display: inline-block;
                    width: 60px;
                     text-align: right;
                }
                p {
                    margin-left: 4px;
                    color: #999999;
                }
            }
            /deep/.el-checkbox {
                margin-right: 20px;
                color: #999999;
            }
            /deep/.el-checkbox__label {
                padding-left: 4px;
            }
        }
        .axis {
            margin-top: 30px;
            /deep/.el-radio {
                margin-right: 20px;
            }
            .time-radio {
                margin-bottom: 20px;
                 margin-top: -5px;
            }
        }
        .direct {
            width:290px;
            .data-type {
                margin-top: 10px;
                margin-bottom: 12px;
                p {
                    margin-bottom: 5px;
                }
                span {
                    color: #999999;
                    margin-right: 10px;
                }
            }
            /deep/.el-tree {
                    width: 100%;
                }
                /deep/.el-tree-node {
                    width: 100%;
                }
           
            
        }
        .variable-tree {
           display: flex;
           .variable-name {
            width: 240px;
            border-right: 1px solid #e6e6e6;
            margin-right: 10px;
            padding-top: 10px;
           
            .name-item {
                margin-bottom: 20px;
                 display: flex;
               align-items: center;
               img {
                   width: 18px;
                   height: 18px;
                   margin-left: 7px;
                   display: none;
               }
               &:hover {
                  img {
                    display: block;
                  }
               }
            }
            .add-icon {
                width: 24px;
                height: 24px;
                border-radius: 50%;
                background-color: #359EFF;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 24px;
                color: #fff;
            }
           }
            
        }
      

    }
    .tab-chat {
        // position: relative;
        display: flex;
        align-items: center;
        justify-content: space-between;

        span {
            display: inline-block;
            padding: 0px 8px;
            margin-right: 20px;
            color: #999999;
            height: 24px;
            border-bottom: 2px solid transparent;
            &.active{
                color: #359EFF;
                border-bottom-color: #359EFF;
            }
        }
        p {
            margin-right: 20px;
            color: #359EFF;
        }
       
    }
  
   
    .weathers {
        .word {
            display: flex;
            align-items: center;
            margin: 20px 0px;
        }
        /deep/.el-checkbox{
            margin-right: 20px;
        }
        /deep/.el-checkbox__input {
            top: -1px;
        }
        /deep/.el-checkbox__label {
            padding-left: 6px;
        }
    }



}
</style>